import { render, staticRenderFns } from "./novaProposta.vue?vue&type=template&id=5da27402&scoped=true"
import script from "./novaProposta.vue?vue&type=script&lang=js"
export * from "./novaProposta.vue?vue&type=script&lang=js"
import style0 from "./novaProposta.vue?vue&type=style&index=0&id=5da27402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da27402",
  null
  
)

export default component.exports